import * as requestFromServer from "./crud";
import { messagingSlice, callTypes } from "./slice";

const { actions } = messagingSlice;

export const fetchFollowers = (queryParams, providerId) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));

  if (!providerId) {
    return dispatch(
      actions.followersFetched({ totalCount: 0, entities: null })
    );
  }

  // const filter = {
  //   ...queryParams,
  //   filter: {
  //     opportunityOpportunityProviderId: { eq: providerId },
  //     ...queryParams.filter,
  //   },
  // };

  //Fetch active route maps and posts
  const queryParams = {
    filterFollower: { status: { eq: 1 } },
    filterRouteMap: { status: { eq: 1 } },
    filterPost: { status: { eq: 1 } },
  };

  return requestFromServer
    .getAllProviderFollowers(providerId, queryParams)
    .then((response) => {
      const { items } = response.data.getOpportunityProvider.followers;
      dispatch(actions.followersFetched({ items }));
    })
    .catch((error) => {
      console.log(error);

      error.clientMessage = "Can't find followers";
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchSeekerConversations = (seekerId, callBack) => (dispatch) => {
  return requestFromServer
    .getSeekerConversations(seekerId)
    .then((response) => {
      var exist = false;
      var conversations = [];
      //   response.data.getSeeker.conversationMembers.items

      if (callBack) callBack(response.data.getSeeker.conversationMembers.items);
    })
    .catch((error) => {
      console.log(error);
    });
};

export const getUserConversation = (seekerId, providerId, callBack) => (
  dispatch
) => {
  dispatch(
    fetchSeekerConversations(seekerId, (response) => {
      var exist = false;
      var existingConversation;

      response.forEach((item) => {
        let conversation = item.conversation;
        if (conversation.type === "PROVIDER") {
          conversation.members.items.forEach((member) => {
            if (providerId === member.providerId) {
              existingConversation = conversation;
              exist = true;
            }
          });
        }
      });

      if (exist && existingConversation) {
        if (callBack) callBack(existingConversation);
      } else {
        var input = {
          type: "PROVIDER",
          title: ``,
          createdAt: new Date(),
          updatedAt: new Date(),
        };
        dispatch(
          createUserConversation(input, (response) => {
            dispatch(
              CreateConverstaionCallback(response, seekerId, providerId)
            );

            if (callBack) callBack(response);
          })
        );
      }
    })
  );
};

const CreateConverstaionCallback = (conversation, seekerId, providerId) => (
  dispatch
) => {
  // var input = {
  //   status: 1,
  //   comment: "",
  //   conversationId: conversation.id,
  //   seekerId: seekerId
  // }
  // dispatch(createConversationMember(input));

  var friend = {
    status: 1,
    comment: "",
    conversationId: conversation.id,
    providerId: providerId,
    seekerId: seekerId,
  };
  dispatch(createConversationMember(friend));
};

export const createConversationMember = (
  conversationMemberForCreation,
  callBack
) => (dispatch) => {
  return requestFromServer
    .createConversationmember(conversationMemberForCreation)
    .then((response) => {
      if (callBack) callBack(response.data.createConversationMember);
    })
    .catch((error) => {
      console.log(error);
    });
};
export const createUserConversation = (conversationForCreation, callBack) => (
  dispatch
) => {
  return requestFromServer
    .createConversation(conversationForCreation)
    .then((response) => {
      if (callBack) callBack(response.data.createConversation);
    })
    .catch((error) => {
      console.log(error);
    });
};

export const getConversationMessagelist = (
  conversationId,
  queryParams,
  callBack
) => (dispatch) => {
  return requestFromServer
    .getConversationMessages(conversationId, queryParams)
    .then((response) => {
      if (callBack) callBack(response.data.messagesByConversationId);
    })
    .catch((error) => {
      console.log(error);
    });
};
export const createUserMessage = (messageForCreation, callBack) => (
  dispatch
) => {
  return requestFromServer
    .createMessage(messageForCreation)
    .then((response) => {
      if (callBack) callBack(response.data.createMessage);
    })
    .catch((error) => {
      console.log(error);
    });
};

export const fetchNotifications = ({ providerId }) => (dispatch) => {
  return requestFromServer
    .getNotifications({ providerId })
    .then((response) => {
      const { items } = response.data.listNotifications;
      dispatch(actions.notificationsFetched({ items }));
    })
    .catch((error) => {
      console.log(error);
    });
};

export const markNotificationsAsRead = ({ notificationId, providerId }) => (
  dispatch
) => {
  return requestFromServer
    .markNotificationAsRead({ notificationId })
    .then(() => {
      dispatch(fetchNotifications({ providerId }));
    })
    .catch((error) => {
      console.error(error);
    });
};

export const markMessageAsRead = (messageToUpdate, providerId, firstName) => (
  dispatch
) => {
  return requestFromServer
    .updateUserMessage(messageToUpdate)
    .then((response) => {
      dispatch(fetchFollowers({}, providerId));
      dispatch(getConversationData(providerId, firstName));
    })
    .catch((error) => {
      console.log(error);
    });
};

export const getConversationData = (providerId) => async (dispatch) => {
  const ids = await requestFromServer.getConversationIds(providerId);
  dispatch(
    actions.conversationDataFetched({
      items: ids.data.getOpportunityProvider.conversationMembers.items.map(
        ({ conversationId, conversation }) => ({
          conversationId,
          unReadCount: conversation.messages.items.filter(
            ({ isSeen, senderId }) => !isSeen && senderId !== providerId
          ),
        })
      ),
    })
  );
};
